// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"afb46968","239":"e08491ac","732":"9ac07411","976":"60b5bd0b"}[chunkId] + ".chunk.js";
};